






























import Vue, { PropOptions } from 'vue';
import NOC from '@/class/common/const';

export interface IRelationData {
  id: number;
  contents: string[];
}

export default Vue.extend({
  name: 'RelationList',
  props: {
    title: String,
    list: Array as PropOptions<IRelationData[]>,
    mode: {
      type: String,
      default: '',
    },
  },
  computed: {
    MODE_NORMAL(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NORMAL);
    },
    MODE_SELECT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.SELECT);
    },
    MODE_EDIT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.EDIT);
    },
    MODE_NEW(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NEW);
    },
  },
  methods: {
    checkMode(mode: string) {
      return this.mode === mode;
    },
    onClickAdd() {
      this.$emit('add');
    },
    onClickDelete(id: number) {
      this.$emit('delete', id);
    },
  },
});
